import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableFilterDateComponent } from './table-filter-date.component';
import { MaterialModule } from '../../material-components.module';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
  ],
  declarations: [TableFilterDateComponent],
  exports: [TableFilterDateComponent],
})

export class TableFilterDateModule {
}
